import styles from "./Choice.module.css";

interface ChoiceProps {
  question: {
    id: string;
    name: string;
    questionType: string;
    options: string[];
  };
  value?: string;
  onChange?: (value: string) => void;
  disabled?: boolean;
}

export default function Choice({
  question,
  value = "",
  onChange,
  disabled = false,
}: ChoiceProps) {
  const handleChange = (selectedValue: string) => {
    if (disabled) return;
    onChange?.(selectedValue);
  };

  return (
    <div className={styles.container}>
      <div className={styles.optionsContainer}>
        {question.options.map((option, index) => {
          const isSelected = value === option;
          return (
            <label
              key={index}
              className={`${styles.optionBox} ${
                isSelected ? styles.optionBoxSelected : ""
              } ${disabled ? styles.optionBoxDisabled : ""}`}
            >
              <input
                type="radio"
                name={question.id}
                value={option}
                checked={isSelected}
                onChange={(e) => handleChange(e.target.value)}
                className={styles.radioInput}
                disabled={disabled}
              />
              <span className={styles.optionLabel}>{option}</span>
            </label>
          );
        })}
      </div>
    </div>
  );
}
